import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

// Case-insensitive email validation pattern
const emailRegex =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi;

@Pipe({
  name: 'chatMentions',
})
export class ChatMentionsPipe implements PipeTransform {
  constructor() {}

  transform(value: string, currentUserEmail?: string): SafeHtml {
    if (!value) {
      return value;
    }

    return value.replace(emailRegex, (match) => {
      if (currentUserEmail && match.toLowerCase() === currentUserEmail.toLowerCase()) {
        return `<b class="text-primary">${match}</b>`;
      }
      return `<b>${match}</b>`;
    });
  }
}
